class FlipItem {
    constructor(tileContainer) {
        this.tileContainer = tileContainer
    }

    init() {
        let tileContainers = document.querySelectorAll(this.tileContainer);
        if (tileContainers) {
            tileContainers = Array.prototype.slice.call(tileContainers);
            tileContainers.forEach(tileContainer => {
                tileContainer.addEventListener("touchstart", (e) => {
                    e.currentTarget.classList.add('is-hovered');
                });
                tileContainer.addEventListener("touchend", (e) => {
                    e.currentTarget.classList.remove('is-hovered');
                });
            })
        }
    }
}

export default new FlipItem('.tile-container');